import { Modal, Col, Button, FormGroup, ButtonGroup } from "reactstrap";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import qualityApi from "service/qualityApi";
import { AddBox } from "@mui/icons-material";

const ModalContestationForm = ({
  attendanceId,
  analysisId,
  attendanceLibraryMatchId,
  segmentId,
  attendanceName,
  response,
  updateAttendance,
  setUpdateAttendance,
  scoreBlockIds,
  isBlockScore = false,
}) => {
  const { register, handleSubmit, setValue } = useForm();
  const [toggle, setToggle] = useState(false);
  const [reply, setReply] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleToggleModal = () => {
    setToggle((v) => !v);
    if (toggle) {
      setIsSubmitting(false);
      setReply(null);
    }
  };

  const onSubmit = (data) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    const contestationData = {
      message: data.message,
      suggestedResponse: data.suggestedResponse,
      attendanceId,
      analysisId,
      attendanceLibraryMatchId,
      segmentId,
      attendanceName,
      response,
      scoreBlockIds: isBlockScore ? scoreBlockIds : undefined,
      isBlockScore,
    };

    if (
      !contestationData.message ||
      !contestationData.suggestedResponse ||
      !contestationData.attendanceId ||
      (!contestationData.analysisId &&
        !contestationData.attendanceLibraryMatchId) ||
      !contestationData.segmentId ||
      !contestationData.attendanceName ||
      !contestationData.response
    ) {
      toast.error("Informações insuficientes para iniciar uma contestação.");
      setIsSubmitting(false);
      return;
    } else {
      qualityApi
        .post("/contestation", contestationData)
        .then(() => {
          if (isBlockScore) {
            toast.success(
              "Contestação de bloco enviada com sucesso! Todos os itens do bloco foram contestados.",
            );
          } else {
            toast.success("Contestação enviada com sucesso!");
          }
          setUpdateAttendance(!updateAttendance);
          setToggle(false);
        })
        .catch((e) => {
          console.error(e);
          if (e.response?.data?.message === "Contestation already exists") {
            if (isBlockScore) {
              toast.success(
                "Contestação de bloco já foi registrada anteriormente.",
              );
            } else {
              toast.success("Contestação já foi registrada anteriormente.");
            }
            setUpdateAttendance(!updateAttendance);
            setToggle(false);
          } else {
            toast.error("Erro ao enviar contestação. Tente novamente.");
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  return (
    <Col
      md="4"
      style={{
        padding: 0,
      }}
    >
      <AddBox
        type="button"
        color="inherit"
        fontSize="large"
        onClick={() => setToggle(true)}
        title={
          isBlockScore
            ? "Adicionar contestação para o bloco"
            : "Adicionar contestação"
        }
      />
      <Modal
        className="modal-dialog modal-lg"
        isOpen={toggle}
        toggle={handleToggleModal}
      >
        <div className="modal-header pb-0">
          <div className="modal-title">
            <h3>{isBlockScore ? "Contestação de Bloco" : "Contestação"}</h3>
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleToggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <div>
            {isBlockScore ? (
              <p>
                <strong>Atenção:</strong> Esta contestação será aplicada a todos
                os itens do bloco de score. Todos os prompts e eventos
                avaliáveis relacionados a este bloco receberão o mesmo status de
                contestação.
              </p>
            ) : (
              <p>
                Detalhe os itens que você deseja contestar, incluindo as
                respostas ideais para cada um e a justificativa para a
                contestação.
              </p>
            )}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="pl-lg-2">
              <FormGroup></FormGroup>
            </div>
            <div className="pl-lg-2">
              <FormGroup className="">
                <label className="form-control-label">
                  Descrição da contestação:
                </label>
                <textarea
                  className="form-control-alternative input-text-area"
                  id="response"
                  type="text"
                  {...register("message")}
                  autoComplete="off"
                  required
                  style={{ resize: "none" }}
                />
                <label className="form-control-label mt-2">
                  Resposta sugerida:
                </label>
                <br />
                <ButtonGroup>
                  <Button
                    color="primary"
                    outline
                    onClick={() => {
                      setReply("Sim");
                      setValue("suggestedResponse", "Sim");
                    }}
                    active={reply === "Sim"}
                  >
                    Sim
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={() => {
                      setReply("Não");
                      setValue("suggestedResponse", "Não");
                    }}
                    active={reply === "Não"}
                  >
                    Não
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={() => {
                      setReply("N/A");
                      setValue("suggestedResponse", "N/A");
                    }}
                    active={reply === "N/A"}
                  >
                    N/A
                  </Button>
                </ButtonGroup>
              </FormGroup>
            </div>
            <hr className="my-4" />
            <Button type="submit" color="primary" disabled={isSubmitting}>
              {isSubmitting ? "Enviando..." : "Contestar"}
            </Button>
          </form>
        </div>
      </Modal>
    </Col>
  );
};

export default ModalContestationForm;
